import { useLocation, useNavigate } from "react-router-dom";
import { useIntercom } from "react-use-intercom";
import { Button } from "@freightsimple/ui-core/Controls/Button";
import { NavBarThemeMenuItems } from "../Menus/Internal/NavBarThemeMenuItems";

const HELP_CENTER_URL = "https://help.freightsimple.com";

/**
 * The signed-out hamburger menu's items. Each item owns its handler (menu
 * items must encapsulate their logic, not receive it via props): Help Center
 * is a plain external link, Live Chat opens Intercom, Sign In routes there.
 */
export function NavBarSignedOutMenuItems() {
  const location = useLocation();
  const navigate = useNavigate();
  const { show } = useIntercom();

  const showSignIn = !location.pathname.includes("sign-in");

  return (
    <>
      <Button href={HELP_CENTER_URL}>Help Center</Button>
      <Button onClick={() => show()}>Live Chat & Support</Button>
      {showSignIn && (
        <Button onClick={() => navigate("/sign-in")}>Sign In</Button>
      )}
      {/* On a phone this menu replaces the inline links entirely, so it has to
          carry the theme picker too — otherwise the signed-out picker exists on
          desktop only. */}
      <NavBarThemeMenuItems />
    </>
  );
}
